import { render } from "./AgreeTermsAndConditions.vue?vue&type=template&id=4937672f&scoped=true"
import script from "./AgreeTermsAndConditions.vue?vue&type=script&lang=js"
export * from "./AgreeTermsAndConditions.vue?vue&type=script&lang=js"

import "./AgreeTermsAndConditions.vue?vue&type=style&index=0&id=4937672f&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4937672f"]])

export default __exports__